module.exports = __webpack_public_path__ + "img/thumbnail_WildWaterBuffalo_f_normal.3d9e5a5e.png";